import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideAccountsPayable } from "@tylertech/accounts-payable-module";
import { provideAggregates } from "@tylertech/aggregates-module";
import { provideCharting } from "@tylertech/charting-module";
import { AppOutletComponent, NotificationActionInjector, provideCore } from "@tylertech/core-module";
import { provideGeneralLedger } from "@tylertech/general-ledger-module";
import { provideInfoCard } from "@tylertech/info-card-module";
import { intentRoutes } from "@tylertech/intents-module";
import { provideInventory } from "@tylertech/inventory-module";
import { MetadataActionService, provideMetadata } from "@tylertech/metadata-module";
import { providePackets } from "@tylertech/packets-module";
import { providePersonnel } from "@tylertech/personnel-module";
import { provideProjectAccounting } from "@tylertech/project-accounting-module";
import { providePurchasing } from "@tylertech/purchasing-module";
import { provideReporting } from "@tylertech/reporting-module";
import { provideUtilityBilling } from "@tylertech/utility-billing-module";
import { appRoutes } from "./appRoutes";
import { environment } from "./environments/environment";
import * as services from "./services";

if (environment.production)
{
    enableProdMode();
}

bootstrapApplication(
    AppOutletComponent,
    {
        providers: [
            provideAnimations(),
            provideCore(
                intentRoutes()
                    .concat(appRoutes)),
            provideCharting(),
            provideAggregates(),
            provideInfoCard(),
            providePackets(),
            provideAccountsPayable(),
            provideGeneralLedger(),
            provideInventory(),
            provideMetadata(),
            providePackets(),
            providePersonnel(),
            provideProjectAccounting(),
            providePurchasing(),
            provideReporting(),
            provideUtilityBilling(),
            services.DashboardMetadataService,
            services.InBalanceService,
            // FIXME: Some of the components in library/core need to be moved to a new package higher in the dependency tree than library/metadata
            { provide: NotificationActionInjector, useClass: MetadataActionService }
        ],
    })
    .catch(err => console.error(err));
